/* Depato theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, strings: {} };

  /* Money ---------------------------------------------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}}';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match && match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* Countdown — real end date only; hides when finished ------------------- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el._cd) return;
      var raw = el.getAttribute('data-countdown').trim();
      var end = new Date(raw.length <= 16 ? raw + ':00' : raw).getTime();
      if (isNaN(end)) return;
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
          m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { el.hidden = true; clearInterval(el._cd); return; }
        el.hidden = false;
        var sec = Math.floor(diff / 1000);
        d.textContent = pad(Math.floor(sec / 86400));
        h.textContent = pad(Math.floor(sec % 86400 / 3600));
        m.textContent = pad(Math.floor(sec % 3600 / 60));
        s.textContent = pad(sec % 60);
      }
      tick();
      el._cd = setInterval(tick, 1000);
    });
  }

  /* Cart drawer ----------------------------------------------------------- */
  var drawerId = 'cart-drawer';
  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  function openDrawer() {
    var d = drawer(); if (!d) return false;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var btn = d.querySelector('[data-cart-close].icon-btn'); if (btn) btn.focus();
    return true;
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function renderDrawer(html) {
    var d = drawer(); if (!d || !html) return;
    var tmp = new DOMParser().parseFromString(html, 'text/html');
    var fresh = tmp.querySelector('[data-cart-drawer]'); if (!fresh) return;
    var wasOpen = d.classList.contains('is-open');
    d.innerHTML = fresh.innerHTML;
    d.setAttribute('data-count', fresh.getAttribute('data-count'));
    if (wasOpen) d.classList.add('is-open');
    updateBubble(parseInt(fresh.getAttribute('data-count'), 10) || 0);
  }
  function updateBubble(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = count; b.classList.toggle('is-on', count > 0);
    });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    if (T.cartType !== 'drawer' || !drawer()) return; // fall back to normal POST → cart page
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    if (btn) btn.classList.add('is-loading');
    postJSON(T.routes.cartAdd + '.js', {
      items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || 1, 10) }],
      sections: drawerId
    }).then(function (res) {
      renderDrawer(res.sections && res.sections[drawerId]);
      openDrawer();
      if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1500); }
    }).catch(function (err) {
      alert((err && (err.description || err.message)) || 'Could not add to cart');
    }).finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var toggle = t.closest('[data-cart-toggle]');
    if (toggle && T.cartType === 'drawer' && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-cart-close]')) { closeDrawer(); return; }
    var q = t.closest('[data-qty-set]');
    if (q) {
      var d = drawer(); d.classList.add('is-busy');
      postJSON(T.routes.cartChange + '.js', {
        line: parseInt(q.getAttribute('data-line'), 10),
        quantity: parseInt(q.getAttribute('data-qty-set'), 10),
        sections: drawerId
      }).then(function (res) { renderDrawer(res.sections && res.sections[drawerId]); })
        .finally(function () { d.classList.remove('is-busy'); });
      return;
    }
    var step = t.closest('[data-qty]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty'), 10));
      return;
    }
    if (t.closest('[data-menu-close]')) { var m = t.closest('[data-menu]'); if (m) m.open = false; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); var m = document.querySelector('[data-menu][open]'); if (m) m.open = false; }
  });

  /* Mobile menu: lock page scroll while open, close on outside click ------ */
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('[data-menu]')) document.documentElement.classList.toggle('menu-open', e.target.open);
  }, true);
  document.addEventListener('click', function (e) {
    var m = document.querySelector('[data-menu][open]');
    if (m && !e.target.closest('.drawer-menu__panel') && !e.target.closest('[data-menu] > summary')) m.open = false;
  });

  /* Product page variants & gallery -------------------------------------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-btn]');
    var priceWrap = section.querySelector('[data-price-wrap]');
    var stickerWrap = section.querySelector('[data-pdp-sticker]');
    var stock = section.querySelector('[data-stock]');

    function showMedia(id) {
      if (!id) return;
      section.querySelectorAll('[data-media-id]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == id); });
      section.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-thumb') == id); });
    }
    section.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () { showMedia(b.getAttribute('data-thumb')); });
    });
    var bar = document.querySelector('[data-pdp-bar]');
    if (bar && addBtn) {
      var ticking = false;
      var syncBar = function () {
        ticking = false;
        var show = addBtn.getBoundingClientRect().bottom < 0;
        if (show === bar.classList.contains('is-visible')) return;
        bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', !show);
        var b = bar.querySelector('[data-bar-btn]'); if (b) b.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncBar); } }, { passive: true });
      syncBar();
    }
    var first = section.querySelector('[data-media-id].is-active');
    if (first) showMedia(first.getAttribute('data-media-id'));

    section.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var selected = [];
      section.querySelectorAll('fieldset.opt').forEach(function (fs, i) {
        var c = fs.querySelector('input:checked'); selected[i] = c ? c.value : null;
        var lbl = section.querySelector('[data-opt-label="' + i + '"]'); if (lbl && c) lbl.textContent = c.value;
      });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
      if (!v) { addBtn.disabled = true; addBtn.textContent = T.strings.unavailable; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (v.featured_media) showMedia(v.featured_media.id);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<div class="price price--lg' + (onSale ? ' price--on-sale' : '') + '"><span class="price__now">' + formatMoney(v.price) + '</span>';
      var sticker = '';
      if (onSale) {
        var saving = v.compare_at_price - v.price, pct = Math.floor(saving * 100 / v.compare_at_price);
        html += '<s class="price__was">' + formatMoney(v.compare_at_price) + '</s><span class="price__save">' + (T.strings.youSave || '[amount]').replace('[amount]', formatMoney(saving)) + ' <b>(' + pct + '%)</b></span>';
        sticker = '<span class="sticker sticker--xl' + (pct >= (T.badgeMin || 50) ? ' sticker--mega' : '') + '"><b>−' + pct + '<i>%</i></b><small>' + (T.strings.off || 'OFF') + '</small></span>';
      }
      priceWrap.innerHTML = html + '</div>';
      var barPrice = document.querySelector('[data-bar-price]'), barBtn = document.querySelector('[data-bar-btn]');
      if (barPrice) barPrice.innerHTML = '<div class="price' + (onSale ? ' price--on-sale' : '') + '"><span class="price__now">' + formatMoney(v.price) + '</span>' + (onSale ? '<s class="price__was">' + formatMoney(v.compare_at_price) + '</s>' : '') + '</div>';
      if (barBtn) { barBtn.disabled = addBtn.disabled; barBtn.textContent = addBtn.textContent; }
      if (stickerWrap) stickerWrap.innerHTML = sticker;
      if (stock) stock.textContent = '';
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    });
  }

  /* Tabs ----------------------------------------------------------------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[data-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on);
            var p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  /* Rails ---------------------------------------------------------------- */
  function initRails(root) {
    (root || document).querySelectorAll('[data-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-rail-track]');
      function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' }); }
      var p = rail.querySelector('[data-rail-prev]'), n = rail.querySelector('[data-rail-next]');
      if (p) p.addEventListener('click', function () { go(document.dir === 'rtl' ? 1 : -1); });
      if (n) n.addEventListener('click', function () { go(document.dir === 'rtl' ? -1 : 1); });
    });
  }

  /* Predictive search: results load while typing ------------------------ */
  function initPredictiveSearch(root) {
    if (!T.routes.predictiveSearch) return;
    (root || document).querySelectorAll('[data-predictive-search]').forEach(function (form) {
      if (form._ps) return;
      form._ps = true;
      var input = form.querySelector('input[type="search"]');
      var panel = form.querySelector('[data-ps-panel]');
      if (!input || !panel) return;
      var timer, controller, lastQuery = '', active = -1;

      function options() { return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]')); }
      function setActive(i) {
        var opts = options();
        opts.forEach(function (o, n) { o.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
        active = i;
        var o = opts[i];
        if (o) { // keep the highlighted row visible without scrolling the page
          var top = o.offsetTop, bottom = top + o.offsetHeight;
          if (top < panel.scrollTop) panel.scrollTop = top;
          else if (bottom > panel.scrollTop + panel.clientHeight) panel.scrollTop = bottom - panel.clientHeight;
        }
      }
      function open() { if (!panel.innerHTML.trim()) return; panel.hidden = false; input.setAttribute('aria-expanded', 'true'); form.classList.add('is-ps-open'); }
      function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); form.classList.remove('is-ps-open'); setActive(-1); }

      function search() {
        var q = input.value.trim();
        if (q.length < 2) { lastQuery = ''; panel.innerHTML = ''; close(); return; }
        if (q === lastQuery) { open(); return; }
        lastQuery = q;
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        form.classList.add('is-ps-loading');
        var url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,query' +
          '&resources[limit]=6&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,vendor,tag,variants.title,variants.sku';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            if (q !== input.value.trim()) return; // a newer query is on its way
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var results = doc.querySelector('[data-ps-results]');
            panel.innerHTML = results ? results.outerHTML : '';
            active = -1;
            if (document.activeElement === input) open();
          })
          .catch(function (err) { if (!err || err.name !== 'AbortError') close(); })
          .then(function () { form.classList.remove('is-ps-loading'); });
      }

      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 220); });
      input.addEventListener('focus', function () { if (input.value.trim().length >= 2) { if (input.value.trim() === lastQuery) open(); else search(); } });
      input.addEventListener('keydown', function (e) {
        var opts = options();
        if (e.key === 'ArrowDown' && !panel.hidden) { e.preventDefault(); setActive(active + 1 >= opts.length ? 0 : active + 1); }
        else if (e.key === 'ArrowUp' && !panel.hidden) { e.preventDefault(); setActive(active <= 0 ? opts.length - 1 : active - 1); }
        else if (e.key === 'Enter' && active > -1 && opts[active]) { e.preventDefault(); window.location.href = opts[active].href; }
        else if (e.key === 'Escape') { close(); }
      });
      panel.addEventListener('mousemove', function (e) {
        var o = e.target.closest('[role="option"]');
        if (o) setActive(options().indexOf(o));
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
      form.addEventListener('focusout', function (e) { if (e.relatedTarget && !form.contains(e.relatedTarget)) close(); });
    });
  }

  /* Collection filters: one dropdown at a time, close on outside click ---- */
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('details.filter')) return;
    if (e.target.open) document.querySelectorAll('details.filter[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
    var anyOpen = !!document.querySelector('details.filter[open]');
    document.documentElement.classList.toggle('sheet-open', anyOpen && window.matchMedia('(max-width: 749px)').matches);
  }, true);
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-filter-close]');
    if (closeBtn) { e.preventDefault(); closeBtn.closest('details.filter').open = false; return; }
    if (e.target.closest('details.filter')) return;
    document.querySelectorAll('details.filter[open]').forEach(function (d) { d.open = false; });
  });

  /* Collection filters: auto-submit ------------------------------------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-filter-form] [data-autosubmit]')) e.target.form.submit();
  });

  /* Recommendations ------------------------------------------------------ */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = new DOMParser().parseFromString(html, 'text/html');
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initCountdowns(el); }
      }).catch(function () {});
    });
  }

  function init(root) {
    initCountdowns(root); initTabs(root); initRails(root); initPredictiveSearch(root);
    (root || document).querySelectorAll('[data-product]').forEach(initProduct);
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); initRecommendations(); });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.Depato = { formatMoney: formatMoney, openCart: openDrawer, closeCart: closeDrawer };
})();
